var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBirthday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cake_black_24dp_1_",
    "data-name": "cake_black_24dp (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10905",
    "data-name": "Path 10905",
    d: "M0,0H14V14H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10906",
    "data-name": "Path 10906",
    d: "M11.142,13.287l-.63.624a2.067,2.067,0,0,1-2.852,0l-.624-.624-.636.624A2.009,2.009,0,0,1,5,14.5v1.75h8.167V14.5a2.009,2.009,0,0,1-1.4-.589l-.624-.624ZM12.583,11h-7A.585.585,0,0,0,5,11.583v2.042a1.114,1.114,0,0,0,.782-.333L7.03,12.05l1.243,1.242a1.17,1.17,0,0,0,1.616,0l1.248-1.242,1.242,1.242a1.138,1.138,0,0,0,.788.333V11.583A.585.585,0,0,0,12.583,11Z",
    transform: "translate(-2.083 -4.583)",
    fill: "#d23b7d",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10907",
    "data-name": "Path 10907",
    d: "M8.25,3.5A1.166,1.166,0,0,0,9.417,2.333a1.11,1.11,0,0,0-.169-.6L8.25,0l-1,1.732a1.11,1.11,0,0,0-.169.6A1.17,1.17,0,0,0,8.25,3.5Zm3.5,1.75H8.833V4.083H7.667V5.25H4.75A1.748,1.748,0,0,0,3,7v5.25a.585.585,0,0,0,.583.583h9.333a.585.585,0,0,0,.583-.583V7A1.748,1.748,0,0,0,11.75,5.25Zm.583,6.417H4.167V9.917a2.009,2.009,0,0,0,1.4-.589L6.2,8.7l.624.624a2.067,2.067,0,0,0,2.852,0l.63-.624.624.624a2.009,2.009,0,0,0,1.4.589v1.75Zm0-2.625a1.113,1.113,0,0,1-.788-.332L10.3,7.467,9.055,8.709a1.17,1.17,0,0,1-1.616,0L6.2,7.467,4.948,8.709a1.114,1.114,0,0,1-.782.332V7a.585.585,0,0,1,.583-.583h7A.585.585,0,0,1,12.333,7Z",
    transform: "translate(-1.25)",
    fill: "#d23b7d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthday);
export default __webpack_public_path__ + "static/media/birthday.7d97ff6071a3044b0b655712714e0468.svg";
export { ForwardRef as ReactComponent };